import db from '@/firebase/firestore.js'

class Register {
    Regist(thread, boxMaster) {
        console.log("Regist")
        const self = this
        db.collection("environments").doc(boxMaster.boxIdentificationCode).set(boxMaster).then(function(){
            console.log("regist success")
            thread.$store.commit("notification", {message:"BOXのセンサー情報を更新しました。", isError:false})

            thread.$store.commit("processing", {start:true, message:"サーバーに更新を通知中です…。"})
        
            try {
                const creator = new WebSocket("wss://service.tomson.xyz/myfield_box_manager")
                const request = {
                    boxIdentificationCode: boxMaster.boxIdentificationCode,
                    type: 1011
                }
                creator.onopen = function (e) {
                    console.log("onopen", e)
                    creator.send(JSON.stringify(request))
                }
                creator.onmessage = function (e) {
                    thread.$store.commit("processing")
                    creator.close()
    
                    console.log("onmessage", e.data)
    
                    switch (e.data) {
                        case "success":
                            thread.$store.commit("notification", {message:"サーバーにBOX情報を送信しました。"})
                            break;
                        default:
                            thread.$store.commit("notification", {message:"サーバー処理で異常が発生しました。("+e.data+")", isError: true})
                            thread.mi_writeLog("Sensor/sendBoxMasterUpdated", "サーバー処理で異常が発生しました。("+e.data+")")
                            break;
                    }
                }
                creator.onclose = function (e) {
                    thread.$store.commit("processing")
                    console.log("onclose", e)
                }
                creator.onerror = function (e) {
                    console.log("onerror", e)
                    creator.close()
                    thread.$store.commit("processing")
                    thread.$store.commit("notification", {message:"サーバー処理で異常が発生しました。", isError: true})
                    thread.mi_writeLog("Sensor/sendBoxMasterUpdated", "サーバー処理で異常が発生しました。("+e+")")
                    return
                }
            } catch (error) {
                console.log(error)
                thread.$store.commit("processing")
                thread.$store.commit("notification", {message:"サーバー処理で異常が発生しました。", isError: true})
                thread.mi_writeLog("Sensor/sendBoxMasterUpdated", "サーバー処理で異常が発生しました。("+error+")")
            }
        }).catch (function (error) {
            console.log(error)
            thread.$store.commit("notification", {message:"BOXのセンサー情報の更新に失敗しました。", isError:true})
            thread.mi_writeLog("MaintenanceBox/updatePlace", "BOXのセンサー情報の更新に失敗しました。("+error+")")
        })
    }
}

export default {
    Register
}
